var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotifications(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.3004 8.67737C14.3004 4.83737 12.1956 2.53337 9.72089 1.8507C9.664 0.968924 8.92444 0.257812 8.01422 0.257812C7.104 0.257812 6.36444 0.968924 6.30756 1.8507C3.83289 2.56181 1.728 4.83737 1.728 8.67737C1.728 8.67737 1.728 12.2329 0.192 14.5369C0.192 14.5369 -0.576 16.0729 0.96 16.3289H2.72356H15.04C16.576 16.0729 15.808 14.5369 15.808 14.5369C14.3004 12.2614 14.3004 8.67737 14.3004 8.67737Z",
    fill: "#E8DEF8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.01422 19.7423C9.43645 19.7423 10.5742 18.6045 10.5742 17.1823H5.45422C5.45422 18.576 6.592 19.7423 8.01422 19.7423Z",
    fill: "#E8DEF8"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.b76cca3f3c2c68a98bce805846c3cefa.svg";
export { ForwardRef as ReactComponent };